import _regeneratorRuntime from "C:/mydata/code/local.lzj/sportman/admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "C:/mydata/code/local.lzj/sportman/admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import util from '@/libs/util';
import helper from '@/libs/helper.js';
import axios from '@/plugin/axios';
export default {
  name: 'app',
  watch: {
    '$i18n.locale': 'i18nHandle'
  },
  created: function created() {
    this.i18nHandle(this.$i18n.locale);
    // this.powerCode = localStorage['apcode'] ;
    this.getMessage();
    if (localStorage['username']) {
      this.loadMenu();
    }
  },
  methods: {
    i18nHandle: function i18nHandle(val, oldVal) {
      util.cookies.set('lang', val);
      document.querySelector('html').setAttribute('lang', val);
    },
    getMessage: function getMessage() {
      var that = this;
      // that.getCurrentTeamMessage();
      setInterval(function () {
        if (localStorage['admin_id']) {
          that.getCurrentTeamMessage();
        }
      }, 1000 * 60 * 5);
    },
    getCurrentTeamMessage: function getCurrentTeamMessage() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var url, res, lastMsgId, that;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = helper.apiHost + helper.apiUrl.getTeamMessage;
              _context.next = 3;
              return axios({
                url: url,
                method: 'post',
                data: {
                  admin_id: localStorage['admin_id']
                }
              });
            case 3:
              res = _context.sent;
              //更新未读站内信数量
              _this.$store.dispatch('d2admin/user/setMsgCount', res.data.count, {
                root: true
              });

              //判断最新消息id
              lastMsgId = sessionStorage.getItem("msg_id");
              if (!lastMsgId) {
                lastMsgId = 0;
              }
              if (lastMsgId != res.data.lastId) {
                //弹窗提醒
                that = _this;
                sessionStorage.setItem("msg_id", res.data.lastId);
                _this.$notify({
                  title: '站内信提醒',
                  message: '您有' + res.data.count + '站内信未读，点击跳转查看',
                  position: 'bottom-right',
                  duration: 2000,
                  onClick: function onClick() {
                    that.$router.push({
                      path: '/message'
                    });
                  }
                });
              }
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    loadMenu: function loadMenu() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var data, url, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // console.log('load menu2');
              //加载菜单
              data = {
                id: localStorage['admin_id'],
                username: localStorage['username'],
                place_id: localStorage['place_id']
              }; // console.log("menu data1",data);
              url = helper.apiHost + helper.apiUrl.menuList;
              _context2.next = 4;
              return axios({
                url: url,
                method: 'post',
                data: data
              });
            case 4:
              res = _context2.sent;
              // console.log("menu res",res.data);

              _this2.$store.commit('d2admin/menu/asideSet', res.data);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};